import request from "@/utils/request";

//业务领域
export function getBusinessArea() {
  return request({
    url: `/financing/categories`,
    method: "get",
  });
}

//融资轮次选项
export function getBusinessCount() {
  return request({
    url: `/financing/financingRounds`,
    method: "get",
  });
}

//招商优选选项
export function getOptimization() {
  return request({
    url: `/financing/optimization`,
    method: "get",
  });
}

//列表接口
export function getRzList(data) {
  return request({
    url: `/financing/listFinancingEvent`,
    method: "post",
    data
  });
}